import { useState, useContext, useEffect, createContext, useRef } from "react"
import { sendMessage } from "../utils/message.service"
import { getDocumentHeight } from "../utils/index"
import { useSession } from "./session"

export const sendResize = () => {
  sendMessage({
    action: "resize",
    height: getDocumentHeight(),
  })
}

export const setLoadingStateOnParent = (loadingState) => {
  sendMessage({
    action: "loading",
    loadingState,
  })
  if (!loadingState) {
    sendResize()
  }
}

const Context = createContext()

export const LoadingProvider = ({ children }) => {
  let mounted = useRef(true)
  const [loading, setLoading] = useState(false)
  const { hasSession } = useSession()

  useEffect(async () => {
    if (!hasSession || !mounted) {
      return null
    }
    setLoadingStateOnParent(loading)
    return () => {
      mounted = false
    }
  }, [hasSession, loading])

  return <Context.Provider value={{ loading, setLoading }}>{children}</Context.Provider>
}

export const useLoading = () => useContext(Context)
